/**@param {string}tel */
const formatTelephone = (tel) => {
   let areaCode = tel.substring(0, 3);
   let firstPart = tel.replace(areaCode, '').substring(0, 3);
   let secondPart = tel.replace(areaCode, '').replace(firstPart, '');
   let telephone = firstPart + "-" + secondPart;
   let formatTel = "(" + areaCode + ")" + "-" + telephone;
   return formatTel
}
/**@param {string}email */
export const normalizeAndHashEmail = async (email) => {
   //Convert text in lowercase
   let normalizeEmail = String(email).toLowerCase();
   let emailParts = normalizeEmail.split('@');

   if (emailParts.length > 1 && (emailParts[1] === 'gmail.com' || emailParts[1] === 'googlemail.com')) {
      // Removes any '.' characters from the portion of the email address before
      // the domain if the domain is gmail.com or googlemail.com.
      emailParts[0] = emailParts[0].replaceAll('.', '');
      normalizeEmail = `${emailParts[0]}@${emailParts[1]}`;
   }
   let textInSHA256 = await toSHA256String(normalizeEmail);
   return textInSHA256;
}

/**@param {string}phone */
export const normalizeAndHashPhoneNumber = async (phone) => {
   let formatE164 = formatTelephone(phone);
   let phoneToSHA256 = await toSHA256String(formatE164);
   return phoneToSHA256;
}

/**@param {string} text */
export const toSHA256String = async (text) => {
   const textAsBuffer = new TextEncoder().encode(text);
   const hashBuffer = await window.crypto.subtle.digest("SHA-256", textAsBuffer);
   const hashArray = Array.from(new Uint8Array(hashBuffer));
   const hash = hashArray.map((item) => item.toString(16).padStart(2, "0")).join("");
   return hash;
}
